export let ApprovalRules;
(function (ApprovalRules) {
  ApprovalRules["NON_SEQUENTIAL"] = "NON_SEQUENTIAL";
  ApprovalRules["ANY_CAN_APPROVE"] = "ANY_CAN_APPROVE";
})(ApprovalRules || (ApprovalRules = {}));